export enum PhoneEditorSteps {
    Input,
    Confirm,
}
